/**
 * @class
 * @description Class that replaces hls.js loader
 * Based on: https://github.com/video-dev/hls.js/blob/master/docs/API.md#loader
 * @exports LoaderHlsjs
 */
export default class LoaderHlsjs {
    /**
     * Load method called by hlsjs when requests a url load.
     * Decides what to do checking the type of the request (manifest or segment).
     * It requests manifests normally, and for segments it uses the loader object.
     * @param {Object} context
     * @param {Object} config
     * @param {Object} callbacks
     * @public
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    load(context, config, callbacks) {
        const stats = {
            trequest: performance.now(),
            tload: 0,
            tfirst: 0,
            loaded: 0
        };
        const url = new URL(context.url);
        if (context.type) {
            // Equals to manifest, level, audioTrack, subtitleTrack...
            if (context.type === 'manifest')
                LoaderHlsjs._engine.setManifestResource(context.url);
        }
        const success = (segment) => {
            callbacks.onSuccess({
                url: segment.url,
                data: segment.data
            }, stats, context);
        };
        const failed = () => {
            //console.log(`here ${JSON.stringify(context)}`);
            callbacks.onError({ code: 400, text: 'something failed :/' }, context);
        };
        if (context.frag || context.type) {
            LoaderHlsjs._engine.request(url, true, [success, failed], undefined, undefined, undefined, stats);
        }
        else {
            console.error('load', context, config, callbacks, stats);
        }
    }
    /**
     * Abort method called by hlsjs when aborting a request.
     * @public
     */
    abort() {
        // Nothing
    }
    /**
     * Destroy method called by hlsjs when destroying a request.
     * @public
     */
    destroy() {
        this.abort();
    }
    /**
     * Generates an object with the times and size of the requests.
     * @param {number} size byte size of the request.
     * @returns {Object} object with times and size.
     * @private
     */
    static _getReqTimes(size) {
        const now = performance.now();
        return {
            trequest: now - 150,
            tfirst: now - 100,
            tload: now,
            loaded: size
        };
    }
}
